var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-video-icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    d: "M21.1231 14.9293L14.0711 10.3064C13.2199 9.74833 12.0894 10.359 12.0894 11.3769L12.0894 20.6228C12.0894 21.6406 13.2199 22.2513 14.0711 21.6932L21.1231 17.0703C21.8941 16.5649 21.8941 15.4348 21.1231 14.9293Z",
    fill: "#5F6F7C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 29.44C23.4227 29.44 29.44 23.4227 29.44 16C29.44 8.57729 23.4227 2.56 16 2.56C8.57729 2.56 2.56 8.57729 2.56 16C2.56 23.4227 8.57729 29.44 16 29.44ZM16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#5F6F7C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayVideoIcon);
export default __webpack_public_path__ + "static/media/play-video-icon.8f691c8cf35aecedacd1d0948c5e3170.svg";
export { ForwardRef as ReactComponent };